import React from 'react';

function Icon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <g clipPath="url(#clip0_78_147)">
        <path d="M12 0.5C14.5068 0.5 17.0137 0.630921 19.5205 0.892764C22.0658 1.15928 23.999 3.30459 24 5.86377V15.1362C23.999 17.6954 22.0658 19.8407 19.5205 20.1072C17.0137 20.3691 14.5068 20.5 12 20.5C9.49316 20.5 6.98633 20.3691 4.47949 20.1072C1.93423 19.8407 0.000993624 17.6954 0 15.1362V5.86377C0.000993624 3.30459 1.93423 1.15928 4.47949 0.892764C6.98633 0.630921 9.49316 0.5 12 0.5ZM11.4382 7.5H7V8.97692H8.38247V13.5H10.0558V8.97692H11.4382V7.5ZM13.5976 7.5H11.6454L13.243 13.5H15.4382L17 7.5H15.1713L14.4343 11.6099H14.3586L13.5976 7.5ZM6 21.5H18C18.5523 21.5 19 21.9477 19 22.5C19 23.0523 18.5523 23.5 18 23.5H6C5.44772 23.5 5 23.0523 5 22.5C5 21.9477 5.44772 21.5 6 21.5Z" />
      </g>
      <defs>
        <clipPath id="clip0_78_147">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Icon;
